<template>
  <div>
    <div class="row  mt-1">
      <div class="col" style="text-align: center;">
        <h3>Declaration</h3>
        <div>
          Please read the declaration
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="row">
          <div v-html="wording[2].declaration.text"></div>
          <div v-html="wording[2].declaration.text2"></div>
        </div>
        <div class="row">
          <div class="col" style="text-align: right;">
            <br><br>
            <h5 class="card-title text-success" >I accept the above declaration and confirm that my abstract complies with it</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm" style="text-align: center;">
        <button class="btn btn-success mx-auto" v-on:click="newAbstract(2)">Cancel</button>
      </div>
      <div class="col-sm" style="text-align: center;">
        <button class="btn btn-success mx-auto" v-on:click="newAbstract(1)">Accept</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'

export default {
  name: "Declaration",
  data() {
    return {
      submitted: false,
    };
  },
  methods: {
    ...mapActions([
      'CREATE_ABSTRACT', 'UPDATE_REFERENCE'
    ]),
    newAbstract(type) {
      if (type === 1){
        let template = {
          "user_id": this.user.id,
          "type_id": 6,
          "setting_submission_id": 3,
          "reference_number": this.getSettings(3).reference_number,
          "content": {},
          "status_id": 1
        };
        this.CREATE_ABSTRACT(template).then((response) => {
          this.$noty.success(this.wording[0].notify.save_success);
          this.$router.push('abstract/' + response.data.id + '/dynamic/' + this.getFirstCurrentPage(3).id)
        }).catch((error) => {
          this.$noty.error(this.wording[0].notify.save_not_success);
        });
      }
      else {
        this.$router.push('/Home');
        return;
      }
    }
  },
  computed: {
    ...mapState([
      'wording', 'user'
    ]),
    ...mapGetters([
      'getSettings', 'getFirstCurrentPage'
    ]),
  },
}
</script>

<style scoped>

</style>